import {
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  title,
  domain1Color,
  domain2Color,
  domain3Color,
  domain4Color,
  domain5Color,
  domain6Color,
  domain7Color
} from "assets/jss/material-kit-pro-react.jsx";

const pdRecommendationStyle = {
  domainCircleScoreStyle: {
    // maxWidth: "120px",
    margin: "0 auto",
    padding: "0px"
  },
  image: {
    maxWidth: "100px"
  },
  iconWrapper: {
    float: "left",
    marginTop: "24px",
    marginRight: "10px"
  },
  d1: {
    color: domain1Color[0]
  },
  d2: {
    color: domain2Color[0]
  },
  d3: {
    color: domain3Color[0]
  },
  d4: {
    color: domain4Color[0]
  },
  d5: {
    color: domain5Color[0]
  },
  d6: {
    color: domain6Color[0]
  },
  d7: {
    color: domain7Color[0]
  },
  warning: {
    color: warningColor
  },
  danger: {
    color: dangerColor
  },
  success: {
    color: successColor
  },
  info: {
    color: infoColor
  },
  rose: {
    color: roseColor
  },
  gray: {
    color: grayColor
  },
  icon: {
    width: "36px",
    height: "36px"
  },
  descriptionWrapper: {
    color: grayColor,
    overflow: "hidden"
  },
  title,
  description: {
    color: grayColor,
    overflow: "hidden",
    marginTop: "0px",
    fontSize: "14px"
  },
  iconWrapperVertical: {
    float: "none"
  },
  iconVertical: {
    width: "61px",
    height: "61px"
  }
};

export default pdRecommendationStyle;
